<template>
    <div>
        <el-form :inline="true" @keyup.enter.native="getDataList()">
            <el-form-item>
                <el-button size="small" @click="getDataList()">刷新分组列表</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="reloadConfig()">重置配置</el-button>
                <el-button size="small" @click="clearCache()">清除缓存</el-button>
            </el-form-item>
            <el-form-item style="float: right">
                <el-button size="small" type="primary" @click="addOrUpdateHandle()">新增分组</el-button>
            </el-form-item>
        </el-form>
        <config-group-item v-for="(group,index) in groupList"
                           :groupId="group.id"
                           :key="index"
                           :groupInfo="group"
                           :busType="busType"
                           @refreshDataList="getDataList"
                           :formId="formId"></config-group-item>
        <span v-if="groupList==undefined || groupList.length==0">暂无分组</span>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>

    </div>
</template>

<script>
    import AddOrUpdate from "./DetailConfigDatasetGroupAdd"
    import ConfigGroupItem from "./DetailConfigDatasetGroupListItem"
    import {
        apiCustomformFromdatasetfieldClear,
        apiCustomformFromdatasetfieldReload,
        apiCustomformFromdatasetgroupList
    } from "../../server/formConfig";

    export default {
        props: {
            formId: {
                type: String,
                required: true,
            },
            busType: {
                type: String,
                required: true,
            },
        },
        components: {
            AddOrUpdate, ConfigGroupItem
        },
        data() {
            return {
                groupList: [],
                addOrUpdateVisible: false,
            };
        },
        activated() {
            // this.getDataList();
        },
        mounted() {
            this.getDataList();
        },
        methods: {
            // 新增 / 修改
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(this.formId, id)
                })
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true;
                const params = {
                    filter: {
                        formId: this.formId,
                    },
                    page: 1,
                    rows: 100,
                }
                apiCustomformFromdatasetgroupList(params).then(({data}) => {
                    if (data) {
                        this.groupList = data.rows;
                    } else {
                        this.groupList = [];
                    }
                    this.dataListLoading = false;
                });
            },
            //重置配置
            reloadConfig() {
                apiCustomformFromdatasetfieldReload(this.formId).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                });
            },
          clearCache(){
            this.$confirm(`是否继续清除缓存?`, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "danger",
            })
                .then(() => {
                    const params = {
                        formId:this.formId
                    }
                    apiCustomformFromdatasetfieldClear(params).then(({data}) => {
                    if (data && data.code === "1") {
                      this.$emit("refreshDataList");
                      this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                          this.getDataList();
                        },
                      });
                    } else {
                      this.$message.error(data.msg);
                    }
                  });
                })
                .catch(() => {
                });
          },
        },

    };
</script>
